import React, { FC } from 'react';
import { MediumBanner } from 'store/landing/types';
import styles from './MultiLPDescription.module.scss';
import LPDescription from './LPDescription';

export interface LPDescriptionProps {
  cards: MediumBanner[];
}

const MultiLPDescription: FC<LPDescriptionProps> = ({ cards }) => {
  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        {cards.map((card) => (
          <div
            className={styles.card}
            key={card.entryId}
            style={{
              flexBasis: `${100 / cards.length}%`,
            }}
          >
            <LPDescription title={card.title} description={card.description1} description2={card.description2} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MultiLPDescription;
